import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { NgTemplateOutlet } from '@angular/common';
import { BxCardComponent, BxCardHeaderComponent } from '@beyonnex/bx-angular-ui';
import { TranslatePipe } from '@ngx-translate/core';
import { CommonTranslateService } from '../../../services/common-translate/common-translate.service';
import { getSeverityClass } from '../../../utils/utils';
import { PropertyDetailsStore } from '../property-details.store';
import { MATRIX_DEVICE_TYPES, MATRIX_SEVERITY_DISPLAY_ORDER } from '../property-details.models';

@Component({
  selector: 'bxi-property-status-matrix',
  imports: [BxCardComponent, BxCardHeaderComponent, NgTemplateOutlet, TranslatePipe],
  templateUrl: './property-status-matrix.component.html',
  host: { class: 'block' },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PropertyStatusMatrixComponent {
  private readonly store = inject(PropertyDetailsStore);
  private readonly commonTranslate = inject(CommonTranslateService);

  protected readonly matrixData = toSignal(this.store.statusMatrix$);
  protected readonly columns = MATRIX_DEVICE_TYPES;
  protected readonly severityDisplayOrder = MATRIX_SEVERITY_DISPLAY_ORDER;
  protected readonly getSeverityClass = getSeverityClass;
  protected readonly translateSeverityLabel = this.commonTranslate.translateCardinality;
  protected readonly translateDeviceTypeKey = (key: string): string => this.commonTranslate.translateOption(key, 'thing.type');
  protected readonly translateDeviceTypeAbbreviation = (key: string): string =>
    this.commonTranslate.translateOption(key, 'thing.type.abbreviation');
  protected readonly isGatewayGroupStart = (key: string): boolean =>
    key === MATRIX_DEVICE_TYPES.find(({ includeInTotal }) => !includeInTotal)?.key;
}
